import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';

import { ReactComponent as PlusIcon } from '@pkg/assets/icons/v2/plus.svg';
import { Portal, PortalArea } from '@pkg/components';

import { CreateNewPodModal } from '@app/pages/Pods/components/CreateNewPod/components';
import { PathParams } from '@app/routes/types';

import { GroupItemInfo, GroupItemWrapper } from '../GroupsNavigationDesktop/styles';
import { GroupItemMobileWrapper } from '../GroupsNavigationMobile/components/GroupItemMobile/styles';
import { GroupCreateNewPodTextMobile } from '../GroupsNavigationMobile/styles';

import { GroupCreateNewPodPlus, GroupCreateNewPodText } from './styles';

export interface GroupCreateNewPodProps {
    isMobile?: boolean;
}

export function GroupCreateNewPod({ isMobile = false }: GroupCreateNewPodProps) {
    const { t: translate } = useTranslation(['groups']);

    const { [PathParams.GroupId]: groupId } = useParams();
    const locationState = useLocation().state as { newPodId?: string };

    // If this is a new Pod and the user has just landed
    // on this Pod page after creating a new Pod, the Modal
    // defaults to `show` to enable the success screen.
    const [showModal, setShowModal] = useState(Boolean(groupId && locationState?.newPodId));

    function handleCloseModal() {
        setShowModal(false);
    }

    async function handleCreatePod() {
        setShowModal(true);
    }

    const buttonMarkup = isMobile ? (
        <GroupItemMobileWrapper onClick={handleCreatePod}>
            <GroupCreateNewPodPlus>
                <PlusIcon />
            </GroupCreateNewPodPlus>

            <GroupCreateNewPodTextMobile>
                {translate('pod_navigator_create_new_pod_mobile')}
            </GroupCreateNewPodTextMobile>
        </GroupItemMobileWrapper>
    ) : (
        <GroupItemWrapper onClick={handleCreatePod}>
            <GroupCreateNewPodPlus>
                <PlusIcon />
            </GroupCreateNewPodPlus>

            <GroupItemInfo>
                <GroupCreateNewPodText>{translate('pod_navigator_create_new_pod')}</GroupCreateNewPodText>
            </GroupItemInfo>
        </GroupItemWrapper>
    );

    // TODO: Should be conditionally rendered like this:
    // const modalMarkup = showModal ? <CreateNewPodModal show={showModal} onClose={handleCloseModal} /> : null;

    const modalAreaMarkup = (
        <Portal destination={PortalArea.Transition}>
            <CreateNewPodModal show={showModal} onClose={handleCloseModal} />
        </Portal>
    );

    return (
        <>
            {buttonMarkup}
            {modalAreaMarkup}
        </>
    );
}
